import { createSlice } from '@reduxjs/toolkit'
import Invoice from 'state/models/Invoice'
import { useObjSelector } from 'utils'
import API from './API'

const initialState = {
	list: [],
}

const slice = createSlice({
	name    : 'invoices',
	initialState,
	reducers: {
		load: (state, { payload: invoices }) => { state.list = invoices },
		clearInvoices: state => initialState
	},
})

slice.thunks = {
	fetchInvoices: async (dispatch) => {
		const result = await API.get('invoice')
		dispatch(slice.actions.load(result.data))
	},
}

export const useInvoices = () => useObjSelector(({ invoices }) => Invoice.map(invoices.list))

export const { clearInvoices } = slice.actions

export const { fetchInvoices } = slice.thunks
export default slice.reducer
